// @ts-ignore

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { ContentBlock } from "@/components/wpl/content-block/src/content-block";

export interface TryPageHeaderProps {
    dividerColor: string;
    headerText: string;
}

export const TryPageHeader = (props: TryPageHeaderProps) => {
    const { dividerColor, headerText } = props;

    const headerStyles = css({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".text-section": {
            "color": "#253858",
            "padding": "16px 16px 0 0",
            "lineHeight": "1.33333333",
            "marginBlockStart": "0",
            "letterSpacing": "0",

            // adjust paddingBottom to accomodate gap coming from Row component marginBlockStart (marginBlockStart + paddingBottom = 32px)
            [media.below.sm]: {
                paddingBlockEnd: "8px" // 24px + 8px = 32px
            },
            [media.above.sm]: {
                paddingBlockEnd: "0px" // 32px + 0px = 32px
            },

            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& h2": {
                "@media (max-width: 767px)": {
                    fontSize: "1.5rem",
                    marginBlockEnd: "14px"
                },
                "@media (min-width: 768px)": {
                    fontSize: "2.25rem",
                    marginBlockEnd: "14px"
                },
                "@media (min-width: 1024px)": {
                    marginBlockEnd: "24px"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& > hr": {
                background: dividerColor,
                height: "4px",
                lineHeight: "16px",
                width: "140px",
                border: "0",
                marginBlockEnd: "0"
            }
        }
    });

    return (
        <div css={headerStyles}>
            <ContentBlock
                headerText={headerText}
                headerType={"h2"}
                horizontalRule={true}
            />
        </div>
    );
};
